import React, { useState, useEffect, useRef, useCallback } from 'react';

import mapboxgl from 'mapbox-gl';

import styles from "./styles.module.css";

import { isEqual } from 'lodash';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getColorByDeviceKey } from './race/RaceColors.js';


import { Panel, PanelGroup } from "react-resizable-panels";
import ResizeHandle from "./ResizeHandle.js";


import DatabaseService from "../services/database.service.js";
import BackendService from "../services/backend.service.js";
import AuthService from "../services/auth.service";
import MQTTService from '../services/MQTTService';
import RaceDataService from './race/RaceDataService';

import RaceCard from './race/RaceCard';
import RaceMap from './race/RaceMap';
import RaceGrid from './race/RaceGrid';

import { captureScreenshot } from '../common/ScreenshotPerfs.js';


import '../services/isMobile.js'

const BoardRace = (props) => {

  const [raceDevices, setRaceDevices] = useState([]);
  const [raceDevicesFiltered, setRaceDevicesFiltered] = useState([]);

  const [selectedCombinations, setSelectedCombinations] = useState([]);
  // const [hiddenDatasets, setHiddenDatasets] = useState([]);
  const [showTraj, setShowTraj] = useState(false);
  const [trackUser, setTrackUser] = useState(false);
  const [mapFitInProgress, setMapFitInProgress] = useState(false);

  const [deviceCoordsHist, setDeviceCoordsHist] = useState({});
  const [currentData, setCurrentData] = useState({});
  const [minMaxValues, setMinMaxValues] = useState({});

  const currentUser = AuthService.getCurrentUser();

  const mapRef = useRef(null);
  const prevFilteredRef = useRef([]);

  // const isNarrowScreen = useMediaQuery({ minWidth: 1224 })
  const isDesktop = (!window.mobileCheck()) // || isNarrowScreen

  // console.log("BoardRace / isDesktop", isDesktop);
  const scalingClass = !isDesktop ? 'scale-down' : '';

  const [intervalRefreshRacers, setIntervalRefreshRacers] = useState(undefined);

  const deviceFirstSeenTimestamps = useRef(new Map());

  function deepEqual(arr1, arr2) {
    return isEqual(arr1, arr2);
  }


  useEffect(() => {

    MQTTService.setUserAndPassword(localStorage.getItem("user"), localStorage.getItem("vloupk"), localStorage.getItem("race_team"));
    MQTTService.connect();

    return () => {
      // EventBus.off('newData', handleNewData);
      MQTTService.disconnect();
    };
  }, []);


  const handleDataUpdate = useCallback((updatedData) => {
    // console.log("BoardRace / handleDataUpdate", Date.now(), updatedData);

    setCurrentData(updatedData.currentData);
    setMinMaxValues(updatedData.minMaxValues);
    setDeviceCoordsHist(updatedData.deviceCoordsHist);

  }, [/*deviceCoordsHist*/]);


  useEffect(() => {
    RaceDataService.setData(selectedCombinations, raceDevicesFiltered /*, hiddenDatasets*/);
  }, [selectedCombinations, raceDevicesFiltered]);

  useEffect(() => {
    RaceDataService.on('dataUpdated', handleDataUpdate);

    return () => {
      console.log("BoardRace / removeListener");
      RaceDataService.removeListener('dataUpdated', handleDataUpdate);
    };
  }, []);


  // console.log("BoardRace / update");
  const handleDeviceSelectionChange = useCallback(async (row, isChecked) => {
    const newSelectedCombinations = { id: row.id, mac_custom: row.mac_custom.toLowerCase(), race_username: row.race_username, race_team: row.race_team };
    if (newSelectedCombinations) {
      const topic = "raceteam/" + row.race_team + "/device/" + newSelectedCombinations.mac_custom.toUpperCase() + "/#";
      console.log("BoardRace / handleDeviceSelectionChange / topic", topic);
      if (isChecked) {
        console.log("BoardRace / handleDeviceSelectionChange / add", newSelectedCombinations.mac_custom)
        setSelectedCombinations(prev => [...prev, newSelectedCombinations]);
        await MQTTService.subscribe(topic);
        RaceDataService.updateData()
      } else {
        console.log("BoardRace / handleDeviceSelectionChange / remove", newSelectedCombinations.mac_custom)
        setSelectedCombinations(prev => prev.filter((item) =>
          item.mac_custom.toLowerCase() !== newSelectedCombinations.mac_custom.toLowerCase()));
        setTimeout(() => {
          console.log("BoardRace / handleDeviceSelectionChange / remove on timeout", newSelectedCombinations.mac_custom);
          RaceDataService.removeDevice(newSelectedCombinations.mac_custom);
        }, 1000)
        await MQTTService.unsubscribe(topic);
        RaceDataService.removeDevice(newSelectedCombinations.mac_custom);
        RaceDataService.updateData()
      }
      console.log("BoardRace / handleDeviceSelectionChange / selectedCombinations", selectedCombinations);
    } else {
      console.log("BoardRace / handleDeviceSelectionChange / error");
    }
  }, [selectedCombinations]);

  // Load selected combinations from localStorage when the component mounts
  useEffect(() => {
    const initialize = async () => {
      try {
        console.log("BoardRace / useEffect []");
        const savedCombinations = localStorage.getItem('selectedCombinations');
        const showTraj = localStorage.getItem('showTraj');
        const trackUser = localStorage.getItem('trackUser');
  
        if (savedCombinations) {
          const restoreSelectedCombinations = JSON.parse(savedCombinations);
          setSelectedCombinations(restoreSelectedCombinations); // Assuming setSelectedCombinations updates state correctly
  
          // Prepare topics for MQTT subscription
          const topics = restoreSelectedCombinations.map(selectedItem => {
            const topic = `raceteam/1/device/${selectedItem.mac_custom.toUpperCase()}/#`;
            console.log("BoardRace / useEffect / subscribe", topic);
            return topic; // Return the topic directly
          });
  
          await MQTTService.setTopics(topics); // Assuming MQTTService.setTopics takes an array of strings
        } else {
          setSelectedCombinations([]); // This ensures the component state is reset appropriately
        }
  
        if (showTraj) {
          setShowTraj(JSON.parse(showTraj));
        }
        if (trackUser) {
          setTrackUser(JSON.parse(trackUser));
        }
  
        loadRaceUsers();
        
        if (intervalRefreshRacers !== undefined) {
          clearInterval(intervalRefreshRacers);
        }
  
        const intervalRefreshRacersTmp = setInterval(() => {
          loadRaceUsers();
        }, 2000);
  
        setIntervalRefreshRacers(intervalRefreshRacersTmp);
      } catch (error) {
        console.error("BoardRace / useEffect initialization error:", error);
      }
    };
  
    initialize();
  
    // Optional Cleanup: If you need to clean up the interval on unmount
    return () => {
      if (intervalRefreshRacers !== undefined) {
        clearInterval(intervalRefreshRacers);
      }
    };
  }, []);
  
  // Save selected combinations to localStorage whenever they change
  useEffect(() => {
    // console.log("BoardRace / useEffect selectedCombinations");
    localStorage.setItem('selectedCombinations', JSON.stringify(selectedCombinations));
  }, [selectedCombinations]);


  useEffect(() => {
    // console.log("BoardRace / useEffect showTraj");
    localStorage.setItem('showTraj', JSON.stringify(showTraj));
  }, [showTraj]);

  useEffect(() => {
    // console.log("BoardRace / useEffect trackUser");
    localStorage.setItem('trackUser', JSON.stringify(trackUser));
  }, [trackUser]);


  /* 
    if (!previousChartData.current) {
      previousChartData.current = chartData;
    }
    const finalChartData = isFrozen ? previousChartData.current : chartData;
  
  
    // Store the current chart data for future reference if not frozen
    useEffect(() => {
      // console.log("BoardRace / useEffect isFrozen, chartData");
      if (!isFrozen) {
        previousChartData.current = chartData;
      }
    }, [isFrozen, chartData]);
   */


  function deviceFirstSeenTimestamp(deviceId) {
    return deviceFirstSeenTimestamps.current.get(deviceId);
  }

  // Function to perform the merge
  function mergeData(devices, activityData) {
    return devices.map(device => {
      // Normalize mac_custom for case-insensitive comparison
      const macCustomLower = device.mac_custom.toLowerCase();

      // Find the matching activity based on mac_custom, ignoring case
      const match = activityData.data.find(activity => activity.mac_custom.toLowerCase() === macCustomLower);


      let dateDiff = 0;
      if (match) {
        dateDiff = Date.now() - match.date;
        // console.log("BoardRace / mergeData / dateDiff", device.ble_name, dateDiff);
      }

      if (match && (!deviceFirstSeenTimestamps.current.has(device.id) || deviceFirstSeenTimestamps.current.get(device.id) == 0) && (dateDiff < 2 * 60000)) {
        deviceFirstSeenTimestamps.current.set(device.id, Date.now());
        console.log("BoardRace / mergeData / set   deviceFirstSeenTimestamp", device.ble_name, deviceFirstSeenTimestamps.current.get(device.id));
      } else if (deviceFirstSeenTimestamps.current.has(device.id) && (deviceFirstSeenTimestamps.current.get(device.id) != 0) && (dateDiff > 2 * 60000)) {
        deviceFirstSeenTimestamps.current.set(device.id, 0);
        console.log("BoardRace / mergeData / reset deviceFirstSeenTimestamp", device.ble_name, deviceFirstSeenTimestamps.current.get(device.id));
      }


      if (device.ble_name == "Smart-19") {
        let test = 1
      }

      // If a match is found, merge the team and date
      if (match) {
        return {
          ...device, // Spread existing device properties
          race_team: parseInt(match.race_team, 10), // Convert team to number and add/update race_team
          last_timestamp: match.date, // Add/update last_timestamp with the date from activity
          first_timestamp: deviceFirstSeenTimestamps.current.get(device.id) // Add/update last_timestamp with the date from activity
        };
      }

      // Return the device as is if no match is found
      return device;
    });
  }

  const loadRaceUsers = () => {
    // console.log("BoardRace / loadRaceUsers");
    DatabaseService.getPerfsRaceDevices().then((response) => {
      let raceUsers = response.data.filter((item) => (item.user_id !== "unknown@old.com"));

      // console.log("BoardRace / loadRaceUsers / getPerfsRaceDevices", raceUsers);

      BackendService.getPerfsRaceDevicesActivity().then((response) => {

        // console.log("BoardRace / loadRaceUsers / getPerfsRaceDevicesActivity", response.data);

        raceUsers = mergeData(raceUsers, response.data);

        setRaceDevices(raceUsers);

        const newFiltered = raceUsers.map(device => ({ mac_custom: device.mac_custom, ble_name: device.ble_name }));
        // console.log("BoardRace / loadRaceUsers / newFiltered", newFiltered);

        if (!deepEqual(newFiltered, prevFilteredRef.current)) {
          setRaceDevicesFiltered(newFiltered);
          prevFilteredRef.current = newFiltered;
          console.log("BoardRace / loadRaceUsers / newFiltered => update");
        }
      }).catch((error) => {
        console.log("BoardRace / loadRaceUsers / getPerfsRaceUsers / error", error);
      });
    }).catch((error) => {
      console.log("BoardRace / loadRaceUsers / getPerfsRaceUsers / error", error);
    });
  }

  useEffect(() => {
    if (selectedCombinations.length === 0 || raceDevices.length === 0) {
      return;
    }

    // Create a map for quicker ID to race_user lookup
    const idToRaceUserMap = raceDevices.reduce((acc, cur) => {
      acc[cur.id] = cur.race_username; // Map each id to its race_user
      return acc;
    }, {});

    // Filter and map in one step
    const updatedSelectedCombinations = selectedCombinations.reduce((acc, item) => {
      if (idToRaceUserMap.hasOwnProperty(item.id)) {
        acc.push({ ...item, race_username: idToRaceUserMap[item.id] }); // Add race_user to item
      }
      return acc;
    }, []);

    // Check if update is necessary
    if (updatedSelectedCombinations.length !== selectedCombinations.length) {
      console.warn("Some IDs in selectedCombinations were not available in raceDevices and have been removed.");
      setSelectedCombinations(updatedSelectedCombinations);
    }

  }, [selectedCombinations, raceDevices]);

  //--------------------------------------------------
  //--------------------------------------------------

  const resizeMap = (timeout = 0) => {
    setTimeout(() => {
      if (mapRef?.current) {
        mapRef?.current.getMap().resize();
      }
    }, timeout)
  }

  const fitMapToGlobalTracks = () => {
    const allTracks = Object.values(deviceCoordsHist);
    const allCoordinates = allTracks.reduce((acc, track) => {
      return acc.concat(track.longitude.map((lng, index) => [lng, track.latitude[index]]));
    }, []);

    const bounds = allCoordinates.reduce((bounds, coord) => {
      return bounds.extend(coord);
    }, new mapboxgl.LngLatBounds());

    const map = mapRef.current.getMap();

    setMapFitInProgress(true);

    // Avoid user tracking when map is moving
    const onMoveEnd = () => {
      map.off('moveend', onMoveEnd);
      setMapFitInProgress(false);
    };
    map.on('moveend', onMoveEnd);

    // Adjust map viewport to fit the bounds
    map.fitBounds(bounds, {
      padding: { top: 40, bottom: 40, left: 40, right: 40 },
      maxZoom: 18,
    });
  };


  const switchShowTraj = () => {
    setShowTraj(!showTraj);
  }

  if (currentUser && currentUser.email !== undefined && currentUser.email !== null && (currentUser.race_team == 0)) {
    return (<h2>Feature not avaible for {currentUser.email}. Contact Rage Mechanics at contact@rage-mechanics.com to join a race team.</h2>)
  }

  // console.log("BoardRace / render / ", Date.now(), selectedCombinations);

  return (
    <>
      <ToastContainer />
      {isDesktop &&
        <div className={styles.Container} style={{ height: '93vh', flex: "1" }}>
          <PanelGroup direction="horizontal">
            <Panel
              collapsible={true}
              defaultSize={20}
              order={1}
              onResize={() => resizeMap()}
              onCollapse={() => resizeMap(500)}
            >
              <PanelGroup direction="vertical">
                <Panel className={styles.Panel}
                  defaultSize={55}
                  collapsible={true}
                  onResize={() => resizeMap()}
                  onCollapse={() => resizeMap(500)}
                >
                  <RaceGrid raceDevices={raceDevices} selectedCombinations={selectedCombinations} handleDeviceSelectionChange={handleDeviceSelectionChange} isDesktop={isDesktop} />

                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                    <button
                      className="btn btn-outline-primary m-1"
                      style={{ flex: 1 }}
                      onClick={fitMapToGlobalTracks}>
                      Center on users
                    </button>
                    <button
                      className={`btn m-1 ${trackUser ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                      style={{ flex: 1 }}
                      onClick={() => setTrackUser(!trackUser)}
                    >
                      Following user 1
                    </button>
                    <button
                      className={`btn m-1 ${showTraj ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                      style={{ flex: 1 }}
                      onClick={switchShowTraj}>
                      Users trajectories
                    </button>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {/*  
                   <button
                      className={`btn m-1 ${isFrozen ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                      style={{ flex: 1 }}
                      onClick={() => setIsFrozen(!isFrozen)}>
                      Freeze chart
                    </button> 
                    */}

                    <button
                      className="btn btn-outline-primary m-1"
                      style={{ flex: 1 }}
                      onClick={() => captureScreenshot(['captureZoneRace1', 'captureZoneRace2'])}>
                      Screenshot
                    </button>


                  </div>


                </Panel>
                <ResizeHandle iconName={"fa fa-up-down"} />
                <Panel
                  className={styles.Panel}
                  onResize={() => resizeMap()}
                  onCollapse={() => resizeMap(500)}
                  collapsible={true}
                  id="map"
                >

                  <RaceMap
                    deviceCoordsHist={deviceCoordsHist}
                    mapRef={mapRef}
                    showTraj={showTraj}
                    trackUser={trackUser && !mapFitInProgress}
                    selectedCombinations={selectedCombinations}
                    forcedSelectedCircuit={undefined}
                    isDesktop={isDesktop}
                    toast={toast}
                  />

                </Panel>
              </PanelGroup>
            </Panel>
            <ResizeHandle iconName={"fa fa-left-right"} />
            <Panel
              collapsible={true}
              // defaultSize={80}
              order={2}
            >
              <PanelGroup direction="vertical">

                <Panel
                  className={styles.Panel}
                  collapsible={true}
                  defaultSize={70}
                  minSize={40}
                  order={1}
                >

                  <div className="row" id='captureZoneRace1' style={{ overflow: 'auto' }}>
                    <div className="card" style={{ marginLeft: '2rem', marginTop: '0rem', alignSelf: 'baseline' }}>
                      <div className="row" style={{ backgroundColor: 'var(--color-card)', alignSelf: 'baseline' }}>

                        <div style={{ width: '160px', marginLeft: '1rem', alignSelf: 'baseline' }}>
                          <RaceCard key={'titles'} index={-1} deviceData={undefined} toast={toast} />
                        </div>

                        {currentData && currentData.length > 0 && currentData.map((deviceData, index) => {

                          const key = deviceData.mac_custom

                          const deviceDetails = raceDevices.find(
                            (device) => device.mac_custom.toLowerCase() === key.toLowerCase()
                          );

                          const deviceMinMax = minMaxValues[key]

                          const color = getColorByDeviceKey(key.toLowerCase())

                          // console.log("BoardRace / currentData / deviceMinMax", deviceMinMax, " / color", color)
                          // console.log("BoardRace / currentData / ", deviceData.mac_custom)
                          return (
                            <div key={key} style={{ width: '300px', marginLeft: '1rem', alignSelf: 'baseline' }}>
                              <RaceCard key={key} index={index} deviceData={deviceData} deviceDetails={deviceDetails} markerColor={color} deviceMinMax={deviceMinMax} toast={toast} />
                            </div>
                          );
                        })}

                      </div>
                    </div>
                  </div>

                </Panel>
                {/*
                <ResizeHandle iconName={"fa fa-up-down"} />
                <Panel
                  className={styles.Panel}
                  order={2}
                  collapsible={true}
                >
                  <div id='captureZoneRace2' style={{ height: '100%' }}>
                    <RaceLineChart chartData={chartData} hiddenDatasets={hiddenDatasets} setHiddenDatasets={setHiddenDatasets} isDesktop={isDesktop} />
                  </div>
                </Panel>
                */}
              </PanelGroup>
            </Panel>
          </PanelGroup >
        </div >
      }
      {
        !isDesktop && <>

          <div style={{ flex: "1" }}>

            <RaceGrid raceDevices={raceDevices} selectedCombinations={selectedCombinations} handleDeviceSelectionChange={handleDeviceSelectionChange} isDesktop={isDesktop} />

            <div style={{ height: '10px' }} />

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
              <button
                className="btn btn-outline-primary m-1"
                style={{ flex: 1 }}
                onClick={() => captureScreenshot(['captureZoneRace1'])}>
                Screenshot
              </button>
              <button className="btn btn-outline-primary m-1" style={{ flex: 1 }} onClick={fitMapToGlobalTracks}>
                Center on users
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                className={`btn m-1 ${showTraj ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                style={{ flex: 1 }} onClick={switchShowTraj}>
                Users trajectories
              </button>
              <button
                className={`btn m-1 ${trackUser ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                style={{ flex: 1 }} onClick={() => setTrackUser(!trackUser)}
              >
                Following user 1
              </button>
            </div>

            <div style={{ height: '20px' }} />

            <div style={{ height: '300px' }} id="map" >
              <RaceMap
                deviceCoordsHist={deviceCoordsHist}
                mapRef={mapRef}
                showTraj={showTraj}
                trackUser={trackUser && !mapFitInProgress}
                selectedCombinations={selectedCombinations}
                forcedSelectedCircuit={undefined}
                isDesktop={isDesktop}
                toast={toast}
              />
            </div>

            <div style={{ height: '70px' }} />

            <div id='captureZoneRace1' >
              {/* margin for screenshot */}
              <div className={scalingClass} style={{ margin: '0.3rem' }} >
                {currentData && currentData.length > 0 && currentData.map((deviceData, index) => {

                  const key = deviceData.mac_custom

                  const deviceDetails = raceDevices.find(
                    (device) => device.mac_custom.toLowerCase() === key.toLowerCase()
                  );

                  const deviceMinMax = minMaxValues[key]

                  const color = getColorByDeviceKey(key.toLowerCase())

                  return (
                    <div key={key + "div1"} className="row" style={{ width: '100%' }}>
                      <div key={key + "div2"} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginBottom: '2rem' }}>
                        <div key={key + "div3"} style={{ flex: '0 0 170px', marginLeft: '1rem' }}>
                          <RaceCard key={'titles'} index={-1} deviceData={undefined} toast={toast} />
                        </div>
                        <div key={key + "div4"} style={{ flex: '0 0 300px', marginLeft: '1rem' }}>
                          <RaceCard key={key} index={index} deviceData={deviceData} deviceDetails={deviceDetails} markerColor={color} deviceMinMax={deviceMinMax} toast={toast} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
          </div>

        </>
      }
    </>
  );
};

export default BoardRace;